import styled from 'styled-components';

export const FriendCollectionPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px 48px;
`;

export const FriendCollectionHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 24px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 24px;

    h2 {
        color: #FFFFFF;
        font-size: 24px;
        margin: 0;
    }
`;

export const BackButton = styled.button`
    background: none;
    border: none;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 16px;
    padding: 8px 0;
    text-align: left;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }
`;

